/** Shared helpers for marketplace search bar validation. */

export function isMarketplaceLocationComplete(locationLabel, coords) {
  return Boolean(
    String(locationLabel || "").trim() &&
      coords?.latitude &&
      coords?.longitude &&
      Number.isFinite(Number(coords.latitude)) &&
      Number.isFinite(Number(coords.longitude))
  );
}

export function isMarketplaceDateComplete(searchDate) {
  if (!searchDate) return false;
  const d = new Date(`${searchDate}T12:00:00`);
  return !Number.isNaN(d.getTime());
}

export function canSubmitMarketplaceSearch({ careTypeEngaged, serviceTab, locationLabel, coords, searchDate }) {
  return Boolean(
    careTypeEngaged &&
      serviceTab &&
      isMarketplaceLocationComplete(locationLabel, coords) &&
      isMarketplaceDateComplete(searchDate)
  );
}

export function getMarketplaceSearchValidationError({
  careTypeEngaged,
  serviceTab,
  locationLabel,
  coords,
  searchDate,
}) {
  if (!careTypeEngaged || !serviceTab) {
    return "Please select a care type to continue.";
  }
  if (!String(locationLabel || "").trim()) {
    return "Please enter a location before searching.";
  }
  if (!isMarketplaceLocationComplete(locationLabel, coords)) {
    return "Please pick a city or area from the suggestions.";
  }
  if (!isMarketplaceDateComplete(searchDate)) {
    return "Please select a start date before searching.";
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const picked = new Date(`${searchDate}T12:00:00`);
  const max = new Date(today);
  max.setDate(max.getDate() + 6);
  if (!Number.isNaN(picked.getTime()) && picked > max) {
    return "Unable to book. Keep a window of 7 days to book any service.";
  }
  return "";
}
